module.exports = __webpack_public_path__ + "img/enterprise_banner3_2.13aaa880.png";